export default "__VITE_ASSET__CiGZ0Y1$__"